const classification = [
  {
    id: 'GL',
    label: 'Gestión Legislativa',
    children: [
      {
        id: 'GL-PR',
        label: 'Presidencia',
        children: [
          {
            id: 'GL-PR-CO',
            label: 'Correspondencia'
          },
          {
            id: 'GL-PR-CV',
            label: 'Convenios'
          },
          {
            id: 'GL-PR-GP',
            label: 'Gestión de prensa'
          },
          {
            id: 'GL-PR-DO',
            label: 'Donaciones'
          },
          {
            id: 'GL-PR-CE',
            label: 'Certificaciones'
          }
        ]
      },
      {
        id: 'GL-PL',
        label: 'Pleno',
        children: [
          {
            id: 'GL-PL-SE',
            label: 'Sesiones'
          },
          {
            id: 'GL-PL-SL',
            label: 'Secretaría Legislativa',
            children: [
              {
                id: 'GL-PL-SL-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-PL-SL-GA',
                label: 'Gestión Administrativa'
              },
              {
                id: 'GL-PL-SL-SG',
                label: 'Secretaría General',
                children: [
                  {
                    id: 'GL-PL-SL-SG-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-PL-SL-SG-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-PL-SL-SC',
                label: 'Secretaría de Comisión',
                children: [
                  {
                    id: 'GL-PL-SL-SC-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-PL-SL-SC-GA',
                    label: 'Gestión Administrativa'
                  },
                  {
                    id: 'GL-PL-SL-SC-FO',
                    label: 'Formularios'
                  }
                ]
              },
            ]
          },
          {
            id: 'GL-PL-SP',
            label: 'Secretaría de Participación Popular',
            children: [
              {
                id: 'GL-PL-SP-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-PL-SP-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-PL-SC',
            label: 'Secretaría de Comisión',
            children: [
              {
                id: 'GL-PL-SC-FO',
                label: 'Formularios',
              }
            ]
          },
          {
            id: 'GL-PL-PI',
            label: 'Secretaría de Participación y Consulta Indígena',
            children: [
              {
                id: 'GL-PL-PI-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-PL-PI-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-PL-ST',
            label: 'Secretaria Técnica',
            children: [
              {
                id: 'GL-PL-ST-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-PL-ST-GA',
                label: 'Gestión Administrativa'
              }
            ]
          }
        ]
      },
      {
        id: 'GL-MD',
        label: 'Mesa Directiva (P-VP)',
        children: [
          {
            id: 'GL-MD-SE',
            label: 'Sesión de Mesa'
          },
          {
            id: 'GL-MD-CO',
            label: 'Correspondencia'
          }
        ]
      },
      {
        id: 'GL-MA',
        label: 'Mesa Directiva Ampliada',
        children: [
          {
            id: 'GL-MA-SE',
            label: 'Sesión de Mesa'
          }
        ]
      },
      {
        id: 'GL-GA',
        label: 'Gabinete'
      },
      {
        id: 'GL-AP',
        label: 'Asesoría Plurinacional'
      },
      {
        id: 'GL-SG',
        label: 'Secretaría de la Convención Constitucional',
        children: [
          {
            id: 'GL-SG-CO',
            label: 'Correspondencia'
          },
          {
            id: 'GL-SG-CA',
            label: 'Cabildos'
          }
        ]
      },
      {
        id: 'GL-CT',
        label: 'Comisiones transitorias',
        children: [
          {
            id: 'GL-CT-CO',
            label: 'Comunicaciones, Información y Transparencia',
            children: [
              {
                id: 'GL-CT-CO-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CT-CO-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CT-CO-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CT-PA',
            label: 'Comisión Presupuesto y Administración Interior',
            children: [
              {
                id: 'GL-CT-PA-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CT-PA-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CT-PA-GA',
                label: 'Gestión Administrativa'
              },
              {
                id: 'GL-CT-PA-EO',
                label: 'Subcomisión de Estructura Orgánica y Gestión de las Personas',
                children: [
                  {
                    id: 'GL-CT-PA-EO-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CT-PA-EO-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CT-PA-EO-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-CT-PA-PR',
                label: 'Subcomisión de Presupuestos',
                children: [
                  {
                    id: 'GL-CT-PA-PR-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CT-PA-PR-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CT-PA-PR-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              }
            ]
          },
          {
            id: 'GL-CT-DH',
            label: 'Comisión Derechos Humanos, Verdad Histórica y Bases para la Justicia, Reparación y Garantías de no Repetición',
            children: [
              {
                id: 'GL-CT-DH-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CT-DH-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CT-DH-GA',
                label: 'Gestión Administrativa'
              },
              {
                id: 'GL-CT-DH-VH',
                label: 'Subcomisión de Verdad Histórica, Reparación Integral y Garantías de no Repetición',
                children: [
                  {
                    id: 'GL-CT-DH-VH-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CT-DH-VH-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CT-DH-VH-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-CT-DH-MG',
                label: 'Subcomisión de Marco General de Derechos Humanos, Ambientales y de La Naturaleza',
                children: [
                  {
                    id: 'GL-CT-DH-MG-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CT-DH-MG-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CT-DH-MG-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              }
            ]
          },
          {
            id: 'GL-CT-DE',
            label: 'Comisión Descentralización, Equidad y Justicia Territorial',
            children: [
              {
                id: 'GL-CT-DE-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CT-DE-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CT-DE-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CT-ET',
            label: 'Comité de Ética, Probidad, Transparencia, Prevención y Sanción de las Violencias',
            children: [
              {
                id: 'GL-CT-ET-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CT-ET-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CT-ET-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CT-PP',
            label: 'Comisión Participación Popular y Equidad Territorial',
            children: [
              {
                id: 'GL-CT-PP-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CT-PP-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CT-PP-GA',
                label: 'Gestión Administrativa'
              },
              {
                id: 'GL-CT-PP-SB',
                label: 'Subcomisión Participación Popular y Equidad Territorial',
                children: [
                  {
                    id: 'GL-CT-PP-SB-SE',
                    label: 'Sesiones'
                  }
                ]
              }
            ]
          },
          {
            id: 'GL-CT-PC',
            label: 'Comisión Participación y Consulta Indígena',
            children: [
              {
                id: 'GL-CT-PC-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CT-PC-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CT-PC-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CT-RE',
            label: 'Comisión de reglamento',
            children: [
              {
                id: 'GL-CT-RE-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CT-RE-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CT-RE-GA',
                label: 'Gestión Administrativa'
              },
              {
                id: 'GL-CT-RE-NC',
                label: 'Subcomisión Reglamento Normas Constitucionales',
                children: [
                  {
                    id: 'GL-CT-RE-NC-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CT-RE-NC-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CT-RE-NC-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-CT-RE-VC',
                label: 'Subcomisión Reglamento Vínculo con Otras Comisiones',
                children: [
                  {
                    id: 'GL-CT-RE-VC-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CT-RE-VC-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CT-RE-VC-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-CT-RE-EO',
                label: 'Subcomisión Reglamento de Estructura Orgánica y Funcionamiento',
                children: [
                  {
                    id: 'GL-CT-RE-EO-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CT-RE-EO-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CT-RE-EO-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
            ]
          }
        ]
      },
      {
        id: 'GL-CP',
        label: 'Comisiones Permanentes',
        children: [
          {
            id: 'GL-CP-CE',
            label: 'Comité de Ética, Probidad, Transparencia, Prevención y Sanción de las Violencias',
            children: [
              {
                id: 'GL-CP-CE-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-CE-EXPS',
                label: 'Expediente Sansoniatorio'
              },
              {
                id: 'GL-CP-CE-GA',
                label: 'Gestión Administrativa'
              },
              {
                id: 'GL-CP-CE-SE',
                label: 'Sesiones'
              }
            ]
          },
          {
            id: 'GL-CP-SP',
            label: 'Comisión Sistema Político, Gobierno, Poder Legislativo, y Sistema Electoral',
            children: [
              {
                id: 'GL-CP-SP-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-SP-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-SP-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-SP-IIC',
                label: 'Iniciativas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-SP-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-SP-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CP-PD',
            label: 'Comisión sobre Principios Constitucionales, Democracia, Nacionalidad y Ciudadanía',
            children: [
              {
                id: 'GL-CP-PD-S1',
                label: 'Subcomisión N°1 Principios Constitucionales',
                children: [
                  {
                    id: 'GL-CP-PD-S1-SE',
                    label: 'Sesiones',
                  },
                  {
                    id: 'GL-CP-PD-S1-GA',
                    label: 'Gestión Administrativa',
                  }
                ]
              },
              {
                id: 'GL-CP-PD-S2',
                label: 'Subcomisión N°2 Principios Constitucionales\n',
                children: [
                  {
                    id: 'GL-CP-PD-S2-SE',
                    label: 'Sesiones',
                  },
                  {
                    id: 'GL-CP-PD-S2-GA',
                    label: 'Gestión Administrativa',
                  }
                ]
              },
              {
                id: 'GL-CP-PD-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-PD-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-PD-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-PD-IIC',
                label: 'Inicitivas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-PD-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-PD-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CP-ES',
            label: 'Comisión Forma de Estado, Ordenamiento, Autonomía, Descentralización, Equidad, Justicia Territorial, Gobiernos Locales y Organización Fiscal',
            children: [
              {
                id: 'GL-CP-ES-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-ES-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-ES-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-ES-IIC',
                label: 'Inicitivas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-ES-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-ES-GA',
                label: 'Gestión Administrativa'
              },
              {
                id: 'GL-CP-ES-S1',
                label: 'Forma de Estado Subcomisión N° 1',
                children: [
                  {
                    id: 'GL-CP-ES-S1-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CP-ES-S1-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CP-ES-S1-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-CP-ES-S2',
                label: 'Forma de Estado Subcomisión N° 2',
                children: [
                  {
                    id: 'GL-CP-ES-S2-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CP-ES-S2-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CP-ES-S2-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              }
            ]
          },
          {
            id: 'GL-CP-DF',
            label: 'Derechos Fundamentales',
            children: [
              {
                id: 'GL-CP-DF-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-DF-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-DF-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-DF-IIC',
                label: 'Inicitivas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-DF-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-DF-GA',
                label: 'Gestión Administrativa'
              },
              {
                id: 'GL-CP-DF-S1',
                label: 'Derechos Fundamentales Subcomisión N° 1',
                children: [
                  {
                    id: 'GL-CP-DF-S1-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CP-DF-S1-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CP-DF-S1-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-CP-DF-S2',
                label: 'Derechos Fundamentales Subcomisión N° 2',
                children: [
                  {
                    id: 'GL-CP-DF-S2-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CP-DF-S2-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CP-DF-S2-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-CP-DF-S3',
                label: 'Derechos Fundamentales Subcomisión N° 3',
                children: [
                  {
                    id: 'GL-CP-DF-S3-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CP-DF-S3-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CP-DF-S3-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              },
              {
                id: 'GL-CP-DF-S4',
                label: 'Derechos Fundamentales Subcomisión N° 4',
                children: [
                  {
                    id: 'GL-CP-DF-S4-CO',
                    label: 'Correspondencia'
                  },
                  {
                    id: 'GL-CP-DF-S4-SE',
                    label: 'Sesiones'
                  },
                  {
                    id: 'GL-CP-DF-S4-GA',
                    label: 'Gestión Administrativa'
                  }
                ]
              }
            ]
          },
          {
            id: 'GL-CP-MA',
            label: 'Comisión Medio Ambiente, Derechos de la Naturaleza, Bienes Naturales Comunes y Modelo Económico',
            children: [
              {
                id: 'GL-CP-MA-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-MA-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-MA-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-MA-IIC',
                label: 'Inicitivas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-MA-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-MA-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CP-SJ',
            label: 'Comisión Sistema de Justicia, Órganos Autónomos de Control y Reforma Constitucional',
            children: [
              {
                id: 'GL-CP-SJ-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-SJ-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-SJ-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-SJ-IIC',
                label: 'Inicitivas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-SJ-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-SJ-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CP-CT',
            label: 'Comisión Sistemas de Conocimientos, Culturas, Ciencia, Tecnología, Artes y Patrimonios',
            children: [
              {
                id: 'GL-CP-CT-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-CT-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-CT-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-CT-IIC',
                label: 'Inicitivas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-CT-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-CT-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CP-PP',
            label: 'Comisión Participación Popular',
            children: [
              {
                id: 'GL-CP-PP-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-PP-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-PP-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-PP-IIC',
                label: 'Inicitivas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-PP-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-PP-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CP-PI',
            label: 'Comisión de Derechos de los Pueblos Indígenas y Plurinacional',
            children: [
              {
                id: 'GL-CP-PI-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-PI-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-PI-IPC',
                label: 'Iniciativas Populares Constituyentes'
              },
              {
                id: 'GL-CP-PI-IIC',
                label: 'Inicitivas Indígenas Constituyentes'
              },
              {
                id: 'GL-CP-PI-PCDI',
                label: 'Propuesta de norma Catálogo de Derechos Indígenas'
              },
              {
                id: 'GL-CP-PI-ICC',
                label: 'Iniciativas Convencionales Constituyentes'
              },
              {
                id: 'GL-CP-PI-GA',
                label: 'Gestión Administrativa'
              }
            ]
          },
          {
            id: 'GL-CP-ET',
            label: 'Comisión Enlaces Transversales',
            children: [
              {
                id: 'GL-CP-ET-SE',
                label: 'Sesiones'
              },
              {
                id: 'GL-CP-ET-CO',
                label: 'Correspondencia'
              },
              {
                id: 'GL-CP-ET-GA',
                label: 'Gestión Administrativa'
              }
            ]
          }
        ]
      },
      {
        id: 'GL-CC',
        label: 'Convencionales Constituyentes',
        children: [
          {
            id: 'GL-CC-IT',
            label: 'Semanas territoriales'
          },
          {
            id: 'GL-CC-DS',
            label: 'Discursos'
          },
          {
            id: 'GL-CC-CO',
            label: 'Correspondencia'
          },
          {
            id: 'GL-CC-DO',
            label: 'Donativos'
          },
        ]
      },
      {
        id: 'GL-CF',
        label: 'Comisiones de finalización',
        children: [
          {
            id: 'GL-CF-CA',
            label: 'Comisión de Armonización',
            children: [
              {
                id: 'GL-CF-CA-SE',
                label: 'Sesiones',
              },
              {
                id: 'GL-CF-CA-CO',
                label: 'Correspondencia',
              },
              {
                id: 'GL-CF-CA-IS',
                label: 'Insumos',
              },
              {
                id: 'GL-CF-CA-GA',
                label: 'Gestión Adiministrativa',
              }
            ]
          },
          {
            id: 'GL-CF-CT',
            label: 'Comisión de Normas Transitorias',
            children: [
              {
                id: 'GL-CF-CT-SE',
                label: 'Sesiones',
              },
              {
                id: 'GL-CF-CT-CO',
                label: 'Correspondencia',
              },
              {
                id: 'GL-CF-CT-IS',
                label: 'Insumos',
              },
              {
                id: 'GL-CF-CT-GA',
                label: 'Gestión Administrativa',
              }
            ]
          },
          {
            id: 'GL-CF-CP',
            label: 'Comisión de Preámbulo',
            children: [
              {
                id: 'GL-CF-CP-SE',
                label: 'Sesiones',
              },
              {
                id: 'GL-CF-CP-CO',
                label: 'Correspondencia',
              },
              {
                id: 'GL-CF-CP-ICC',
                label: 'Iniciativas Convencionales Constituyentes',
              },
              {
                id: 'GL-CF-CP-IS',
                label: 'Insumos',
              },
              {
                id: 'GL-CF-CP-GA',
                label: 'Gestión Administrativa',
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 'GA',
    label: 'Gestión Administrativa, Financiera y Transparencia',
    children: [
      {
        id: 'GA-DI',
        label: 'Dirección',
        children: [
          {
            id: 'GA-DI-CO',
            label: 'Correspondencia'
          },
          {
            id: 'GA-DI-CE',
            label: 'Certificados'
          }
        ]
      },
      {
        id: 'GA-FI',
        label: 'Finanzas',
        children: [
          {
            id: 'GA-FI-IP',
            label: 'Informe presupuestario'
          }
        ]
      },
      {
        id: 'GA-OS',
        label: 'Operaciones y Servicios Generales'
      },
      {
        id: 'GA-UP',
        label: 'Unidad de Personas',
        children: [
          {
            id: 'GA-UP-CV',
            label: 'Curriculums Vitae'
          }
        ]
      },
      {
        id: 'GA-UT',
        label: 'Unidad de Transparencia e Integridad Pública',
        children: [
          {
            id: 'GA-UT-UTP',
            label: 'Unidad de Transparencia Pasiva',
            children: [
              {
                id: 'GA-UT-UTP-STP',
                label: 'Solicitudes de Transparencia'
              }
            ]
          },
          {
            id: 'GA-UT-UTA',
            label: 'Unidad de Transparencia Activa'
          },
          {
            id: 'GA-UT-DIP',
            label: 'Declaración de Intereses y Patrimonio'
          },
          {
            id: 'GA-UT-LO',
            label: 'Unidad de Lobby'
          }
        ]
      },
      {
        id: 'GA-GD',
        label: 'Unidad de Gestión Documental y Archivo (UGDA)',
        children: [
          {
            id: 'GA-GD-MI',
            label: 'Minutas'
          },
          {
            id: 'GA-GD-RE',
            label: 'Registros de entrega'
          },
          {
            id: 'GA-GD-AT',
            label: 'Actas de transferencia'
          },
          {
            id: 'GA-GD-MN',
            label: 'Manuales'
          },
          {
            id: 'GA-GD-PR',
            label: 'Procedimientos'
          }
        ]
      }
    ]
  },
  {
    id: 'CO',
    label: 'Comunicaciones',
    children: [
      {
        id: 'CO-DP',
        label: 'Declaraciones Públicas'
      },
      {
        id: 'CO-DI',
        label: 'Dirección**',
        children: [
          {
            id: 'CO-DI-CI',
            label: 'Comunicaciones internas'
          },
          {
            id: 'CO-DI-PA',
            label: 'Pauta de Actividades'
          }
        ]
      },
      {
        id: 'CO-CTV',
        label: 'Convención TV',
        children: [
          {
            id: 'CO-CTV-MA',
            label: 'Material audiovisual'
          }
        ]
      },
      {
        id: 'CO-IC',
        label: 'Unidad de Información y Contenidos',
        children: [
          {
            id: 'CO-IC-PU',
            label: 'Publicaciones'
          }
        ]
      },
      {
        id: 'CO-RP',
        label: 'Vínculos, Relaciones Públicas y Protocolos'
      },
      {
        id: 'CO-BA',
        label: 'Banco Audiovisual e Imagen Pública'
      }
    ]
  }
];
export default classification;
